import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { PhotoForHighlights } from '../../../../../graphql/queries/albums';
import PhotoForFacesHighlight from './PhotoForFacesHighlight';
import withFaceHighlightsMutation from '../../hoc/withFaceHighlightsMutation';

const withPhotoForHighlights = graphql(PhotoForHighlights, {
  options: ({ match, photoRecord, albumId, albumPhoto }) => ({
    variables: {
      id: photoRecord?.id || match?.params.photoId,
      albumId: albumPhoto?.album?.id || albumId || match?.params.albumId,
    },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { photo, loading } }) => ({
    faces: photo?.faces.records ?? [],
    faceHighlights: photo?.face_highlights.records ?? [],
    loadingHighlights: loading,
  }),
});

export default compose(
  withRouter,
  withPhotoForHighlights,
  withFaceHighlightsMutation,
)(PhotoForFacesHighlight);
